module.exports = __webpack_public_path__ + "0604381675ed3c7947507a0dcf95e27f.png";